export class DeviceStatus {
    public id: string;
    public text: string;
    public icone: string;

    public constructor(init?: Partial<DeviceStatus>) {
        Object.assign(this, init);
    }
}
